import { DisplayRecommendation, type Tax } from 'src/graphql/generated';

export const getPriceWithTax = (originalPrice: number, tax?: Tax): number => {
  if (!Boolean(tax)) return originalPrice;

  const hasTax = tax && Boolean(tax.code && tax.displayRecommendation);
  const taxPrice = tax?.amount?.value ?? 0;

  return hasTax && tax.displayRecommendation === DisplayRecommendation.inclusive
    ? originalPrice + taxPrice
    : originalPrice;
};
